import t from"vue";var n=t.extend({computed:{$context:function(){return this.$amap.context},$container:function(){return this.$amapMap},$target:function(){return this.$context.target},$map:function(){return this.$amapMap.target},$meta:function(){return this.$options.amapMeta}}});export default n;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@amap/amap-vue/es/mixins/component.js
// module id = null
// module chunks = 